export default [
  {
    path: "CRM",
    name: "CRM",
    component: (): Promise<any> => import(/* webpackChunkName: "crm" */ "@/views/Admin/CRMView.vue")
  }
];
